import React, { useState } from "react";

// Redux
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  FormFeedback,
} from "reactstrap";

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// import images
import logo from "../../assets/images/logo/pappermap-logo-wordmark.png";

import withRouter from "Components/Common/withRouter";
import { BaseButton, BaseInput } from "Components/ui";
import { forgetPassword } from "services/auth.service";
import { handleAPIError } from "utils";

const Login = (props: any) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [isEmailSent, setIsEmailSent] = useState<boolean>(false);

  //meta title
  document.title = "Forgot Password | Papermap";

  // Form validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your email"),
    }),
    onSubmit: (values: any) => {
      handleSubmit(values);
    },
  });

  const handleSubmit = async (data) => {
    // Handle form submission logic here
    setLoading(true);
    try {
      const result = await forgetPassword(data);
      console.log("Result: ", result);
      setIsEmailSent(true);
      validation.resetForm();
    } catch (error) {
      handleAPIError(error, true);
    } finally {
      setLoading(false);
    }
  };

  return (
    <React.Fragment>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <Card className="overflow-hidden">
                <div className="bg-primary-subtle">
                  <Row>
                    <Col>
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Reset Password</h5>
                        {!isEmailSent && (
                          <p>
                            Enter the details below to receive password reset
                            instructions.
                          </p>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div className="auth-logo">
                    <Link to="/" className="auth-logo-light">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="34"
                          />
                        </span>
                      </div>
                    </Link>
                    <Link to="/" className="auth-logo-dark">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-dark">
                          <img
                            src={logo}
                            alt=""
                            className="rounded-circle"
                            height="54"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    {isEmailSent ? (
                      <>
                        <h5 className="text-primary">
                          Reset instructions sent
                        </h5>
                        <p>
                          Check your email and follow the instructions to reset
                          your password
                        </p>
                        <div className="mt-4 d-grid">
                          <BaseButton
                            className="btn btn-primary btn-block"
                            type="submit"
                            loading={loading}
                            disabled={loading}
                            onClick={() =>
                              window.open("https://mail.google.com", "_blank")
                            }
                          >
                            Go to your mail
                          </BaseButton>
                        </div>
                      </>
                    ) : (
                      <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                      >
                        <div className="mb-3">
                          <BaseInput
                            name="email"
                            placeholder="Enter email"
                            type="text"
                            label="Email"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.email || ""}
                            invalid={
                              validation.touched.email &&
                              validation.errors.email
                                ? true
                                : false
                            }
                          />
                          {validation.touched.username &&
                          validation.errors.username ? (
                            <FormFeedback type="invalid">
                              {validation.errors.username}
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mt-4 d-grid">
                          <BaseButton
                            className="btn btn-primary w-md"
                            type="submit"
                            loading={loading}
                            disabled={loading}
                          >
                            Send Instructions
                          </BaseButton>
                        </div>
                      </Form>
                    )}
                  </div>
                </CardBody>
              </Card>
              {!isEmailSent && (
                <div className="mt-5 text-center">
                  <p>
                    Remember your password now?{" "}
                    <Link to="/login" className="fw-medium text-primary">
                      {" "}
                      Go back to Login{" "}
                    </Link>{" "}
                  </p>
                </div>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Login);
